<template>
  <ProjectManagerList :project="project" @input="$emit('input', $event)"/>
</template>

<script>
import ProjectManagerList from '../../../../components/Relations/ProjectManagers/Panels/List'

export default {
  components: {ProjectManagerList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  }
}
</script>
